'use client';
import { BORDER_COLORS } from '@/common/constants';
import { checkType } from '@/common/ultils';
import get from 'lodash/get';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import { twMerge } from 'tailwind-merge';

const SmallFeaturedItem = ({ posts, deviceType }) => {
  const imageUrl = checkType(deviceType === 'mobile' ? 'mobile' : 'tablet', posts, -1);

  return (
    <div className={twMerge('group/item p-1 border-b border-gray-300 border-dashed py-2', BORDER_COLORS.primary)}>
      <Link href={`${posts?.menu?.slug}/${posts.slug}`} className="flex gap-2">
        <div className="shrink-0 h-[70px] max-h-[70px] w-[104px] overflow-hidden rounded">
          {/* <img
            src={imageUrl}
            alt={posts.title.slice(0, 80)}
            className="rounded w-full h-full object-cover mb-2 group-hover/item:scale-105 transition-transform duration-300"
          /> */}
          <Image
            src={imageUrl}
            alt={posts.title}
            fill
            className="rounded w-full h-full object-cover mb-2 group-hover/item:scale-105 transition-transform duration-300 position-initial"
          />
        </div>

        <div className="flex-1">
          <p className="text-sm group-hover/item:text-red-700! font-semibold text-black leading-[18px] pr-2 line-clamp-3 text-justify">
            {posts.title}
          </p>
        </div>
      </Link>
    </div>
  );
};

const FeaturedEvent = ({ featuredEvents, deviceType }) => {
  const t = useTranslations('');
  return (
    <div className={twMerge(`border h-full `, BORDER_COLORS.primary)}>
      <div className="TD-box-news-title relative w-full">
        {/* <div className="title relative w-full"> */}
        <a className="w-full" href="#">
          {t('home.highlightNews')}
        </a>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-2 lg:gap-0">
        {get(featuredEvents, 'results', []).map((posts) => (
          <SmallFeaturedItem key={posts.slug} posts={posts} deviceType={deviceType} />
        ))}
      </div>
    </div>
  );
};

export default FeaturedEvent;
